/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListInvoices200ResponseItemsInnerLocationsInner
 */
export interface ListInvoices200ResponseItemsInnerLocationsInner {
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInnerLocationsInner
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInnerLocationsInner
     */
    locationName: string;
    /**
     * 
     * @type {number}
     * @memberof ListInvoices200ResponseItemsInnerLocationsInner
     */
    amount: number;
}

/**
 * Check if a given object implements the ListInvoices200ResponseItemsInnerLocationsInner interface.
 */
export function instanceOfListInvoices200ResponseItemsInnerLocationsInner(value: object): value is ListInvoices200ResponseItemsInnerLocationsInner {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function ListInvoices200ResponseItemsInnerLocationsInnerFromJSON(json: any): ListInvoices200ResponseItemsInnerLocationsInner {
    return ListInvoices200ResponseItemsInnerLocationsInnerFromJSONTyped(json, false);
}

export function ListInvoices200ResponseItemsInnerLocationsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListInvoices200ResponseItemsInnerLocationsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'locationName': json['locationName'],
        'amount': json['amount'],
    };
}

export function ListInvoices200ResponseItemsInnerLocationsInnerToJSON(json: any): ListInvoices200ResponseItemsInnerLocationsInner {
    return ListInvoices200ResponseItemsInnerLocationsInnerToJSONTyped(json, false);
}

export function ListInvoices200ResponseItemsInnerLocationsInnerToJSONTyped(value?: ListInvoices200ResponseItemsInnerLocationsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'locationName': value['locationName'],
        'amount': value['amount'],
    };
}

